var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#7292F7",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.221 15.5349C10.613 16.1564 9.63088 16.1564 9.02288 15.5268L7.3158 13.7591C6.88708 13.3152 6.89487 12.5968 7.33918 12.169C7.76011 11.7493 8.43047 11.7654 8.8358 12.1851L10.122 13.517L15.1341 8.3269C15.555 7.89103 16.2332 7.89103 16.6541 8.3269L16.6853 8.35919C17.1062 8.79506 17.1062 9.50536 16.6775 9.94123L11.221 15.5349Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/done.7c1c091bd3c76e66060b4b5adf6f2814.svg";
export { ForwardRef as ReactComponent };